const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const desktopNav = document.getElementById('c-nav-primary');
const html = document.documentElement;

document.querySelectorAll('.js-nav-toggle-desktop').forEach((el) => {
  el.addEventListener('click', () => html.classList.toggle('js-desktop-nav'));
});

window.addEventListener('resize', debounce(() => {
  if (desktopNav && window.getComputedStyle(desktopNav).display === 'none') {
    html.classList.remove('js-desktop-nav');
  }
}, 250));
